import type { FormLogicRule } from '../../../../types/forms'

export type FormPayloadField = Record<string, unknown> & {
  id?: string
  type?: string
  label?: string
  required?: boolean
  options?: unknown[]
}

export type FormPayload = Record<string, unknown> & {
  fields: FormPayloadField[]
  logic?: FormLogicRule[]
}

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' ? value as Record<string, unknown> : {}

const asString = (value: unknown, fallback = '') => typeof value === 'string' ? value : fallback

const asPayloadFields = (value: unknown): FormPayloadField[] =>
  Array.isArray(value) ? value.map((field, index) => {
    const record = asRecord(field)
    return {
      ...record,
      id: asString(record.id, `field-${index + 1}`),
      type: asString(record.type, 'text'),
      label: asString(record.label, `Field ${index + 1}`),
      required: record.required === true,
    }
  }) : []

const asLogicRules = (value: unknown): FormLogicRule[] | undefined => {
  if (Array.isArray(value)) return value as FormLogicRule[]
  const record = asRecord(value)
  return Array.isArray(record.rules) ? record.rules as FormLogicRule[] : undefined
}

export const normalizeFormPayload = (value: unknown): FormPayload => {
  const payload = asRecord(value)
  const next: FormPayload = {
    ...payload,
    fields: asPayloadFields(payload.fields),
  }
  const logic = asLogicRules(payload.logic)
  if (logic) next.logic = logic
  return next
}
